module.exports = __webpack_public_path__ + "img/Slide2.jpg";